module.exports = __webpack_public_path__ + "images/img-VS2p8Mq.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/ranks/4.png
// module id = 1761
// module chunks = 0